import { MouseEvent } from 'react';

const Button = ({
    color,
    margin,
    children,
    onClick,
    id,
    disabled,
}: {
    color: string;
    margin: boolean;
    children: JSX.Element | string;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
    id?: string;
    disabled?: boolean;
}) => {
    const base = margin ? `${color}-button margin` : `${color}-button`;
    return (
        <button
            className={disabled ? `${base} disabled` : base}
            id={id}
            onClick={onClick}
            disabled={disabled}
            style={
                disabled
                    ? { opacity: 0.5, cursor: 'not-allowed' }
                    : undefined
            }
        >
            {children}
        </button>
    );
};

export default Button;
